<template>
  <GeneralForm :jenisJurnal="10" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Mutasi Kas Bank',
       url : '/api/ju',
       routeBack : 'jmkblist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>